<template>
    <div class="glcs-wrapper">

        <!-- Retrieve button -->
        <div class="glcs-top-bar">
            <v-btn color="primary" @click="onClick">
                {{ $t('button.retrieveallpayitem') }}
            </v-btn>
        </div>

        <!-- Toolbar -->
        <div class="glcs-toolbar">
            <h2 class="glcs-title">Update Pay Item GL Code</h2>
            <div class="glcs-actions">
                <button class="glcs-btn glcs-btn-csv" @click="getCSVHandler" title="Export CSV">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                        <polyline points="14 2 14 8 20 8"/>
                        <line x1="12" y1="18" x2="12" y2="12"/>
                        <polyline points="9 15 12 18 15 15"/>
                    </svg>
                    <span>CSV</span>
                </button>
                <div class="glcs-search">
                    <v-icon size="18" class="glcs-search-icon">mdi-magnify</v-icon>
                    <input v-model="search" type="text" placeholder="Search..." class="glcs-search-input" />
                </div>
            </div>
        </div>

        <!-- Table -->
        <v-data-table
            dense
            :headers="tabHeaders"
            :items="payitemglList"
            :search="search"
            :items-per-page="15"
            class="glcs-table"
            multi-sort
            fixed-header
        >
            <template v-slot:[`item.action`]="{ item }">
                <div class="glcs-row-actions">
                    <button class="glcs-action-btn" @click="onClickDialog(item)" title="Edit">
                        <v-icon size="14">mdi-pencil</v-icon>
                    </button>
                </div>
            </template>
        </v-data-table>

        <!-- Edit Dialog -->
        <v-dialog v-model="subDialog" max-width="500px" persistent>
            <v-card class="glcs-dialog-card">
                <v-card-title class="glcs-dialog-title">
                    {{ subDialogTitle }}
                    <span class="glcs-dialog-subtitle">{{ subDialogTitleValue }}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-5">
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                outlined
                                dense
                                :label="$t('glcode.debitglcode')"
                                v-model="formData.debitgl"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                outlined
                                dense
                                :label="$t('glcode.creditglcode')"
                                v-model="formData.creditgl"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pb-4 px-5">
                    <v-spacer></v-spacer>
                    <app-formbuttons
                        v-on:SavePressed="saveDialogHandler()"
                        v-on:CancelPressed="cancelDialogHandler"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Save button -->
        <div class="glcs-bottom-bar">
            <v-btn color="success" @click="saveHandler()">
                {{ $t('button.save') }}
            </v-btn>
        </div>

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>
  
  <script>
  import ErrorDialog from "../../../components/common/ErrorDialog";
  
  export default {
    components: {
        "app-error": ErrorDialog,
    },

    props: {
      parentData: Object,
    },

    data() {
      return {
        search: "",
        formTitle: this.$t('glcode.glcode'),

        subDialogTitle: "",
        subDialogTitleValue: "",
        subDialog: false,
        payitemglList: [],
        errMsg: "",
        isErr: false,
        isConfirm: false,

        formData: {
            payitemid: null,
            debitgl: null,
            creditgl: null,
            refpayitemid: null,
        },

        payitemglSaveList: [],

        tabHeaders: [
            { text: this.$t('columns.actions'), value: "action", sortable: false },
            { text: this.$t('workhourspayitemmappingsetup.payitemcode'), value: "payitemcode" },
            { text: this.$t('setupclaim.payitemdescription'), value: "payitemdesc" },
            { text: this.$t('glcode.debitglcode'), value: "debitgl" },
            { text: this.$t('glcode.creditglcode'), value: "creditgl" }
        ],
      };
    },
  
    methods: {

        loadGlCodeSetup() {
            let vm = this;
            
            this.$store.dispatch('get', {url: '/payglcode/all'})
                .then(res => {
                    vm.payitemglList = res.data.rec;
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                });
        },

        onClick() {
            let vm = this;
            
            this.$store.dispatch('get', {url: '/payglcodebypayitemid/all'})
                .then(res => {
                    vm.payitemglList = res.data.rec;
                    for (let i = 0; i < vm.payitemglList.length; i++) {
                        if (!vm.payitemglList[i].updatedby) {
                            vm.payitemglList[i].action = 1
                        } else {
                            vm.payitemglList[i].action = 2
                        }
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                });
        },

        onClickDialog(item) {
            this.subDialogTitleValue = item.payitemcode
            this.subDialogTitle = this.$t('reportsparam.createnew') + " " + this.formTitle;
            this.formData.refpayitemid = item.refpayitemid
            this.formData.debitgl = item.debitgl
            this.formData.creditgl = item.creditgl
            this.formData.payitemid = item.payitemid

            this.subDialog = !this.subDialog
        },
  
        objectToCSV(data) {
            const csvRows = [];
    
            //get header
            const headers = Object.keys(data[0]);
            //const headers = this.titles
            csvRows.push(headers.join(","));
    
            //loop over the rows
            for (const row of data) {
            const values = headers.map((header) => {
                const escaped = ("" + row[header]).replace(/"/g, '\\"');
                return `"${escaped}"`;
            });
            csvRows.push(values.join(","));
            }
            return csvRows.join("\n");
        },
      
        downloadHandler(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.setAttribute("hidden", "");
            a.setAttribute("href", url);
            a.setAttribute("download", this.parentData.pageTitle + ".csv");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },

        async getCSVHandler() {
            let titles = this.parentData.tabHeaders;
            let item = this.parentData.tabItems;
            let data = [];
            let obj2 = {};
    
            titles.forEach((element1) => {
            let x = element1.text;
            obj2[x] = element1.value;
            });
    
            item.forEach((element1) => {
            let obj = {};
            titles.forEach((element2) => {
                if (element2.value != "action") {
                let key = element2.text;
                obj[key] = element1[element2.value];
                }
            });
            data.push(obj);
            });
    
            const csvData = this.objectToCSV(data);
            this.downloadHandler(csvData);
        },

        saveDialogHandler() {
            const index = this.payitemglList.findIndex(obj => obj.payitemid === this.formData.payitemid);
            if (index !== -1) {
                if (!this.formData.payitemid)  {
                    this.formData.action = 1
                } else {
                    this.formData.action = 2
                }
                Object.assign(this.payitemglList[index], this.formData);
            }
            this.subDialog = false;
        },

        cancelDialogHandler() {
            this.subDialog = false;
        },

        saveHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                return false;
            }

            this.$store.dispatch('put', {url: "/payglcode/" + this.$store.getters.userId, payload: this.payitemglList})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    // this.$router.push({ name: "affectitemlist", params: { search: this.search}  });
                    this.onClick()
                }
            }).catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },
    },
  
    mounted(){
        this.search = '';
        this.loadGlCodeSetup();
    },
  };
  </script>
  
  <style scoped>
.glcs-wrapper {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 16px rgba(0,0,0,0.07);
    border: 1px solid #E8EDF5;
    overflow: hidden;
    font-family: 'Inter', 'Segoe UI', sans-serif;
}

.glcs-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background: #F8FAFF;
    border-bottom: 1px solid #E8EDF5;
    flex-wrap: wrap;
    gap: 12px;
}

.glcs-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1E293B;
    margin: 0;
}

.glcs-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.glcs-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 11px;
    border-radius: 7px;
    border: none;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
}

.glcs-top-bar {
    padding: 16px 0 0 16px;
}

.glcs-bottom-bar {
    padding: 16px 0 16px 16px;
}

.glcs-btn-csv {
    background: #ECFDF5;
    color: #059669;
    border: 1px solid #A7F3D0;
}
.glcs-btn-csv:hover {
    background: #059669;
    color: #fff;
    border-color: #059669;
}

.glcs-search {
    position: relative;
    display: flex;
    align-items: center;
}
.glcs-search-icon {
    position: absolute;
    left: 9px;
    color: #94A3B8 !important;
    pointer-events: none;
}
.glcs-search-input {
    padding: 5px 10px 5px 30px;
    border: 1.5px solid #E8EDF5;
    border-radius: 8px;
    font-size: 0.83rem;
    font-family: inherit;
    color: #1E293B;
    background: #fff;
    outline: none;
    width: 220px;
    transition: border-color 0.15s;
}
.glcs-search-input:focus { border-color: #4F6BFF; }
.glcs-search-input::placeholder { color: #94A3B8; }

.glcs-row-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}
.glcs-action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    transition: all 0.12s;
    background: transparent;
    color: #64748B;
}
.glcs-action-btn:hover {
    background: #EEF2FF;
    color: #4F6BFF;
}

.glcs-dialog-card { border-radius: 12px !important; }
.glcs-dialog-title {
    font-size: 0.95rem !important;
    font-weight: 700;
    color: #1E293B;
    padding: 16px 20px 12px;
    gap: 8px;
    flex-wrap: wrap;
}
.glcs-dialog-subtitle {
    font-size: 0.88rem;
    font-weight: 500;
    color: #4F6BFF;
    background: #EEF2FF;
    padding: 2px 8px;
    border-radius: 5px;
}
</style>

<style>
.glcs-table { border-radius: 0 !important; box-shadow: none !important; border: none !important; }
.glcs-table table { background: #fff !important; }
.glcs-table thead tr { background: #F8FAFF !important; }
.glcs-table thead tr th {
    font-size: 0.65rem !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.07em !important;
    color: #64748B !important;
    border-bottom: 2px solid #E8EDF5 !important;
    padding: 4px 8px !important;
    white-space: nowrap !important;
}
.glcs-table tbody tr { transition: background 0.12s !important; }
.glcs-table tbody tr:hover { background: #F5F7FF !important; }
.glcs-table tbody tr td {
    font-size: 0.78rem !important;
    color: #334155 !important;
    border-bottom: 1px solid #F1F5F9 !important;
    padding: 0px 8px !important;
    height: 24px !important;
}
.glcs-table tbody tr:last-child td { border-bottom: none !important; }
.glcs-table.v-data-table--dense tbody tr td { height: 24px !important; }
.glcs-table.v-data-table--dense tbody tr { height: 24px !important; }
.glcs-table .v-data-table__wrapper { overflow-x: auto; }
.glcs-table .v-data-footer {
    background: #F8FAFF !important;
    border-top: 1px solid #E8EDF5 !important;
    font-size: 0.8rem !important;
    color: #64748B !important;
}
</style>